"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwitchSocialLink1Schema = void 0;
exports.TwitchSocialLink1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/twitch-sociallink/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "TwitchSocialLink1",
    "description": "Add a link to a Twitch profile",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:twitch-sociallink:1"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "channelName": {
                    "type": "string",
                    "description": "e.g. `tsm_bjergsen`",
                    "pattern": "^[a-zA-Z0-9_]{3,}$"
                }
            },
            "required": [
                "channelName"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy90d2l0Y2gtc29jaWFsbGluay8xLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLHVCQUF1QixHQUFHO0lBQ3JDLEtBQUssRUFBRSxzRkFBc0Y7SUFDN0YsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsbUJBQW1CO0lBQzVCLGFBQWEsRUFBRSxnQ0FBZ0M7SUFDL0MsTUFBTSxFQUFFLFFBQVE7SUFDaEIsc0JBQXNCLEVBQUUsS0FBSztJQUM3QixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sOENBQThDO2FBQy9DO1NBQ0Y7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixzQkFBc0IsRUFBRSxLQUFLO1lBQzdCLFlBQVksRUFBRTtnQkFDWixhQUFhLEVBQUU7b0JBQ2IsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSxxQkFBcUI7b0JBQ3BDLFNBQVMsRUFBRSxvQkFBb0I7aUJBQ2hDO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YsYUFBYTthQUNkO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFlBQVk7UUFDWixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=